import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { IToasterConfig, ToasterConfig } from 'angular2-toaster';
import { extend } from 'lodash';
import { Subject } from 'rxjs';
import { GLOBAL_CONTAINER_ID } from './toaster.data';
import { ToasterStore } from './toaster.store';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-toaster',
  templateUrl: 'toaster.component.html',
  styleUrls: ['toaster.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToasterComponent implements OnInit, OnDestroy {
  @Input() toasterOptions: any; // if toasterOptions is not set, set options for global container:
  // { toastContainerId = GLOBAL_CONTAINER_ID }

  private _defaultToasterOptions = {
    toastContainerId: GLOBAL_CONTAINER_ID,
    mouseoverTimerStop: true,
    newestOnTop: false,
  };
  private _destroyed: Subject<boolean> = new Subject<boolean>();

  toasterConfig: ToasterConfig;

  constructor(
    private _toasterStore: ToasterStore,
    private _changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    const options = extend(
      {},
      this._defaultToasterOptions,
      this.toasterOptions || {}
    ) as IToasterConfig;

    this.toasterConfig = new ToasterConfig(options);

    this._toasterStore.onToastAdd$
      .pipe(takeUntil(this._destroyed))
      .subscribe(() => this._changeDetectorRef.markForCheck());
  }

  ngOnDestroy() {
    this._destroyed.next(true);
    this._destroyed.unsubscribe();
  }
}
